module.exports = __webpack_public_path__ + "static/media/full-screen.a65076af.svg";